import { getRolePermissions } from '@dispatch/shared/services';
import { Permission } from '@dispatch/shared/types';
import { useQuery } from '../useQuery';

export const useGetRolePermissions = (
  permissionIds: string[],
  enabled: boolean
) => {
  const { data, status, refetch } = useQuery(
    ['permission', permissionIds],
    () => getRolePermissions(permissionIds),
    {
      enabled,
    }
  );

  return {
    data: data?.filter((permission: Permission) => permission !== undefined),
    status,
    refetch,
  };
};
